import DashboardComponent from './Dashboard';

export const Dashboard = DashboardComponent;


// WEBPACK FOOTER //
// ./src/dashboard/index.js